import { usePermissions } from "context/PermissionsContext";
import { useMemo } from "react";
import { findSpecificMenu, findSpecificSubMenu } from "./checkUserRigths";

const clientsSubmenus = [
  "Purchases",
  "Catalog",
  "Dues & Ledger",
  "Quotes & Orders",
  "WIP",
  "NPD Orders",
  "Service Request",
  "Request Visit",
];

const settingsOptions = [
  "Synchronize",
  "Missing Images",
  "Rate Master Rights",
  "Waba Rights",
  "Design Update",
  "Update Images",
  "Labour Rights",
  "Product USP & Gallery",
  "My Binny’s Access",
  "Stock Tray",
  "Event Type",
  "Service Requests",
  "Melting Requests",
  "Orders",
  "Design Import",
  "New Rights",
];

const locationMap = {
  "hq": "Headquarters Stock",
  "bbm": "BBM Stock",
  "bbm_customer_stock": "BBM Customer Stock",
  "bbs": "BBS Stock",
  "bbs_customer_stock": "BBS Customer Stock",
  "idl": "IDL"
};

export const usePermissionFlags = () => {
  const permissions = usePermissions();

  const showClients = useMemo(() => {
    if (!permissions) return false;
    if (permissions?.isAdmin) return true;

    const visionWeb = permissions?.rights?.find(
      (item) => item.menu === "Vision Web"
    );
    if (!visionWeb) return false;

    return visionWeb?.subRights?.some(
      (sub) =>
        clientsSubmenus.includes(sub.subMenu) && sub.enabled === true
    );
  }, [permissions]);

  const showSettings = useMemo(() => {
    if (!permissions) return false;
    if (permissions?.isAdmin) return true;

    const visionWeb = permissions?.rights?.find(
      (item) => item.menu === "Vision Web"
    );
    if (!visionWeb) return false;

    return visionWeb?.subRights?.some((sub) => {
      if (!settingsOptions.includes(sub.subMenu)) return false;

      return sub?.permissions?.some((perm) => perm.allowed === true);
    });
  }, [permissions]);

  const stockLocations = useMemo(() => {

    if(permissions?.isAdmin) return Object.values(locationMap); 
    const stockPermissions = findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Location Access");
    if (!stockPermissions?.permissions) return [];

    const allowedLocations = stockPermissions.permissions
      .filter(permission => permission.allowed === true && locationMap[permission.key])
      .map(permission => locationMap[permission.key]);

    return allowedLocations.length > 0 ? allowedLocations : [];
  }, [permissions]);

  return { stockLocations ,showClients, showSettings };
};